import { InsurerInterface } from 'app/shared/interfaces/Insurer.interface';
import { getInsurerDisplayNameAfterRebranding } from 'app/shared/helpers/getInsurerDisplayNameAfterRebranding';

export const getInsurerDisplayName = (
  insurerName: InsurerInterface['name']
) => {
  switch (insurerName) {
    case 'ycd':
      return 'YCD';
    case 'tuz':
      return 'TUZ';
    case 'mtu24':
      return 'mtu24';
    case 'interrisk':
      return 'InterRisk';
    case 'irys':
      return 'InterRisk';
    case 'wefox':
      return 'Direct';
    default:
      const name = getInsurerDisplayNameAfterRebranding(insurerName);
      return name.charAt(0).toUpperCase() + name.slice(1);
  }
};
